import React, { useRef, useCallback, useMemo } from "react";

import { AgGridOverlay } from "@src/components/overlays/ag_grid_overlay/index";
import { ConfirmationHistoryTabToolBar } from "@src/features/data_confirmation/components/confirmation_history_tab_tool_bar";
import { getGridOptions } from "@src/features/data_confirmation/utils/data_confirmation_history_grid_options";
import { useGetConfirmationsByProjectIdQuery } from "@src/services/apis/projectsApi";
import { AgGridReact } from "ag-grid-react";

interface ConfirmationHistoryTabProps {
  projectId: number;
}

const ConfirmationHistoryTab: React.FC<ConfirmationHistoryTabProps> = ({
  projectId,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const { data: dataConfirmations, isLoading } =
    useGetConfirmationsByProjectIdQuery(projectId);

  const onQuickFilter = useCallback((searchInput: string) => {
    gridRef?.current.api?.setGridOption("quickFilterText", searchInput);
  }, []);

  const gridOptions = useMemo(() => {
    return getGridOptions();
  }, []);

  return (
    <>
      <ConfirmationHistoryTabToolBar
        onQuickFilter={onQuickFilter}
        disabled={isLoading}
      />
      <AgGridReact
        ref={gridRef}
        rowData={dataConfirmations}
        gridOptions={gridOptions}
        overlayComponent={AgGridOverlay}
        overlayComponentParams={{
          loadingMessage: "Loading confirmation history...",
          noRowsMessage: "No Confirmations found",
          customStyle: { marginTop: "48px" },
        }}
      />
    </>
  );
};

export default ConfirmationHistoryTab;
